import {Dealer} from "./interfaces";

const wgs84_a = 6378137.0
const wgs84_b = 6356752.3

function degrees(radians: number) {
  return radians * (180 / Math.PI)
}

function radians(degrees: number) {
  return degrees * (Math.PI / 180)
}

function wgs84_earth_radius(lat: number) {
  const an = wgs84_a * wgs84_a * Math.cos(lat)
  const bn = wgs84_b * wgs84_b * Math.sin(lat)
  const ad = wgs84_a * Math.cos(lat)
  const bd = wgs84_b * Math.sin(lat)
  return Math.sqrt((an * an + bn * bn) / (ad * ad + bd * bd))
}

export function getBoundingBox(latitude: number, longitude: number, half_side_in_km = 25) {
  const latitude_box = radians(latitude)
  const longitude_box = radians(longitude)

  const half_side = 1000 * half_side_in_km

  const radius = wgs84_earth_radius(latitude_box)
  const parallel_radius = radius * Math.cos(latitude_box)

  const north = degrees(latitude_box - half_side / radius)
  const east = degrees(longitude_box + half_side / parallel_radius)
  const south = degrees(latitude_box + half_side / radius)
  const west = degrees(longitude_box - half_side / parallel_radius)

  return {
    north, east, south, west,
  }
}

export function resetBoundingBox(): {north: null, east: null, south: null, west: null} {
  return {
    north: null,
    east: null,
    south: null,
    west: null,
  }
}

export function dealerCleanup(dealer: Dealer) {
  dealer.full_address = dealer.full_address.replace(/(?:\r\n|\r|\n|\\n)/g, "<br>")

  return dealer
}

export function handleLocationError(
  browserHasGeolocation: boolean,
  map: google.maps.Map,
  infoWindow: google.maps.InfoWindow,
  pos: google.maps.LatLng,
) {
  infoWindow.setPosition(pos)
  infoWindow.setContent(
    browserHasGeolocation
      ? "Error: The Geolocation service failed."
      : "Error: Your browser doesn't support geolocation.",
  )
  infoWindow.open(map)
}
